export const QUERY_PARAMS = {
  REGION: 'region',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  CATEGORY: 'category',
  SEARCH_WORD: 'searchWord',
  TERM: 'term',
};
